import { render, staticRenderFns } from "./customer-node.vue?vue&type=template&id=155877ea&scoped=true&"
import script from "./customer-node.vue?vue&type=script&lang=js&"
export * from "./customer-node.vue?vue&type=script&lang=js&"
import style0 from "./customer-node.vue?vue&type=style&index=0&id=155877ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155877ea",
  null
  
)

export default component.exports